import styled from 'styled-components';
import { Stack } from 'components/Stack';
import { ReactComponent as ReturnsRawIcon } from 'icons/returns.svg';

export const Container = styled(Stack).attrs({
  gap: 16,
  justify: 'center',
  align: 'center',
  direction: 'column',
})`
  height: 100%;
  padding: 24px 10px;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`;

export const ReturnsIcon = styled(ReturnsRawIcon)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.configs.CTAButton.bgColor};
`;

export const Title = styled.h3`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`;

export const ExplainingSection = styled.div`
  background-color: ${({ theme }) =>
    theme.configs.CTAButton.bgColor.concat('80')};
  padding: 16px 8px;
`;
